<template>
    <Modal v-model="visible" title="供应商注册" width="660" :mask-closable="false">
        <div slot="header"></div>
        <div slot="footer"></div>
        <span class="modal-title">供应商注册</span>
        <div class="form-content">
            <Form ref="form" :model="form" :rules="rules">
                <!-- <FormItem prop="phone">
                    <Input v-model="form.phone" placeholder="请输入手机号" style="width: 100%;"></Input>
                    <Row type="flex">
                    <Col span="6">
                    <Select v-model="form.countryCode" style="width: 100%;">
                        <Option value="+86">+86</Option>
                        <Option value="+852">+852</Option>
                        <Option value="+853">+853</Option>
                    </Select>
                    </Col>
                    <Col span="14" offset="1">
                    <Input v-model="form.phone" placeholder="请输入手机号" style="width: 100%;"></Input>
                    </Col>
                </Row>
                </FormItem>
                <FormItem prop="code">
                    <div class="code-div">
                        <Input v-model="form.code" placeholder="请输入验证码" style="width:376px"></Input>
                        <Button @click="getCode" :disabled="countdown > 0" class="code-btn">
                            <span class="code-btn-txt" v-if="countdown > 0">
                                <span style="color:red">{{ countdown }}</span><span>秒后重试</span>
                            </span>
                            <span class="code-btn-txt" v-else>获取验证码</span>
                        </Button>
                    </div>
                </FormItem> -->
                <FormItem prop="userName">
                    <Input v-model="form.userName" placeholder="请输入用户名称"></Input>
                </FormItem>
                <FormItem prop="password">
                    <Input v-model="form.password" type="password" placeholder="请输入密码"></Input>
                </FormItem>
                <FormItem prop="companyName">
                    <Input v-model="form.companyName" placeholder="请输入供应商名称"></Input>
                </FormItem>
                <FormItem prop="contactName">
                    <Input v-model="form.contactName" placeholder="请输入联系人"></Input>
                </FormItem>
                <FormItem prop="contactNumber">
                    <Input v-model="form.contactNumber" placeholder="请输入联系电话"></Input>
                </FormItem>
                <FormItem prop="address">
                    <Input v-model="form.address" placeholder="请输入联系地址"></Input>
                </FormItem>
                <FormItem prop="uscCode">
                    <Input v-model="form.uscCode" placeholder="请输入统一信用代码"></Input>
                </FormItem>
                <!-- <FormItem prop="businessCode">
                    <Input v-model="form.businessCode" placeholder="请输入工商注册号"></Input>
                </FormItem> -->
                <FormItem prop="captcha">
                    <div class="captcha-div">
                        <Input v-model="form.captcha" placeholder="请输入图形验证码" style="width:367px"></Input>
                        <img @click="captchaRefresh" class="captcha-refresh"
                            src="../../static/webp1/refresh-captcha.png" alt="">
                        <img class="captcha-img" :src="captchaImgUrl" alt="">
                    </div>

                </FormItem>
            </Form>
            <!-- <Checkbox v-model="agree">
                我已阅读并同意
                <a @click="handleShowProtocol">《相关协议》</a>
            </Checkbox> -->
            <div class="submit-btn" @click="handleSubmit">
                <span>立即注册</span>
            </div>
        </div>
    </Modal>
</template>

<script>
import axios from "axios";
export default {
    data() {
        return {
            visible: false,
            countdown: 0,
            timer: null,
            form: {
                code: "",
                phone: "",
                captcha: "",
                password: "",
                userName: "",
                contactName: "",
                address: "",
                businessCode: "",
                uscCode: "",
                companyName: "",
                contactNumber: "",
            },
            agree: false,
            rules: {
                // phone: [
                //     {
                //         required: true,
                //         message: "请输入手机号",
                //         trigger: "blur",
                //     },
                //     {
                //         validator: (rule, value, callback) => {
                //             const phoneReg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/;
                //             if (!value) {
                //                 return callback(new Error("请输入手机号"));
                //             }
                //             if (!phoneReg.test(value)) {
                //                 return callback(new Error("手机号格式不正确"));
                //             }
                //             callback();
                //         },
                //         trigger: "blur",
                //     },
                // ],
                // code: [
                //     {
                //         required: true,
                //         message: "请输入验证码",
                //         trigger: "blur",
                //     },
                // ],
                password: [
                    { required: true, message: "请输入密码", trigger: "blur" },
                    { min: 6, message: "密码长度不能小于6位", trigger: "blur" },
                ],
                userName: [
                    {
                        required: true,
                        message: "请输入用户名",
                        trigger: "blur",
                    },{
                        pattern: /^[a-zA-Z0-9]+$/,
                        message: '只能输入拼音字母和数字',
                        trigger: 'blur'
                    },
                ],
                companyName: [
                    {
                        required: true,
                        message: "请输入供应商名称",
                        trigger: "blur",
                    },
                ],
                contactNumber: [
                    {
                        required: true,
                        message: "请输入联系人电话",
                        trigger: "blur",
                    },
                ],
                contactName: [
                    {
                        required: true,
                        message: "请输入联系人",
                        trigger: "blur",
                    },
                ],
                address: [
                    {
                        required: true,
                        message: "请输入联系地址",
                        trigger: "blur",
                    },
                ],
                uscCode: [
                    {
                        required: true,
                        message: "请输入统一信用代码",
                        trigger: "blur",
                    },
                    {
                        validator: (rule, value, callback) => {
                            const phoneReg =
                                /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
                            if (!value) {
                                return callback(
                                    new Error("请输入统一信用代码")
                                );
                            }
                            if (!phoneReg.test(value)) {
                                return callback(
                                    new Error("统一信用代码格式不正确")
                                );
                            }
                            callback();
                        },
                        trigger: "blur",
                    },
                ],
                captcha: [
                    {
                        required: true,
                        message: "请输入验证码",
                        trigger: "blur",
                    },
                ],
                // businessCode: [
                //     {
                //         required: true,
                //         message: "请输入工商注册号",
                //         trigger: "blur",
                //     },
                // ],
            },
            captchaImgUrl: "",
            sessionId: "",
        };
    },
    methods: {
        showModal() {
            this.captchaRefresh();
            this.visible = true;
            Object.keys(this.form).forEach(key => {
                this.form[key] = ''; // 或者 obj[key] = '';
            });
        },
        getCode() {
            if (this.countdown > 0) return;
            this.countdown = 60;
            this.timer = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--;
                } else {
                    clearInterval(this.timer);
                    this.timer = null;
                }
            }, 1000);
        },
        handleSubmit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    let params = {
                        password: "",
                        captcha: "",
                        userName: "",
                        uscCode: "",
                        companyName: "",
                        contactName: "",
                        contactNumber: "",
                        address: "",
                    };
                    for (const key in params) {
                        params[key] = this.form[key];
                    }

                    params.password = this.encryptData(params.password, "my-secret-key-12");
                    params.sessionId = this.sessionId;
                    console.log(params, "parmras");
                    let config = {
                        method: "post",
                        url: `${window.osConfig.registerUrl}/supplier/register`,
                        data: params,
                    };
                    axios(config)
                        .then((res) => {
                            if (res.data.code === 0) {
                                this.visible = false;
                                this.$Message.success("供应商注册成功");
                                this.$refs.form.resetFields();
                            } else {
                                debugger
                                let content = res.data.content;
                                let message =
                                    content[Object.keys(content)[0]] ||
                                    "注册失败，请联系管理员";
                                this.$Message.error(message);
                            }
                        })
                        .catch(() => {
                            this.$Message.error("注册失败，请联系管理员");
                            this.visible = false;
                        });
                    //this.visible = false;
                }
            });
        },
        encryptData(data, secretKey) {
            const CryptoJS = require("crypto-js");
            // 使用 AES 加密，指定 ECB 模式和 PKCS7 填充
            const encrypted = CryptoJS.AES.encrypt(
                data,
                CryptoJS.enc.Utf8.parse(secretKey),
                {
                    mode: CryptoJS.mode.ECB,
                    padding: CryptoJS.pad.Pkcs7,
                }
            );

            return encrypted.toString(); // 返回加密后的密文
        },
        captchaRefresh() {
            let config = {
                        method: "get",
                        url: `${window.osConfig.registerUrl}/supplier/captcha`,
                    };
            axios(config).then((res) => {
                const dataURL = "data:image/png;base64," + res.data.content;
                this.captchaImgUrl = dataURL;
                this.sessionId = res.data.message;
            });
        },
        handleShowProtocol() {
            alert("这里可以展示协议内容...");
        },
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    },
};
</script>
<style scoped lang="less">
.submit-btn {
    width: 100%;
    height: 40px;
    background-image: linear-gradient(92deg, #135dff 0%, #50a4ff 95%);
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    span {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        color: #ffffff;
    }
}
.modal-title {
    font-family: PingFangSC-Medium;
    font-weight: 600;
    font-size: 32px;
    color: #000000;
}
.form-content {
    margin-top: 17px;
}
.code-div {
    display: flex;
    .code-btn {
        margin-left: 6px;
        height: 40px;
        flex: 1;
        .code-btn-txt {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 16px;
            color: #222222;
        }
    }
}
.captcha-div {
    display: flex;
    align-items: center;
    .captcha-refresh {
        width: 24px;
        height: 24px;
        margin: 0 8px;
        cursor: pointer;
    }
    .captcha-img {
        width: 87px;
        height: 40px;
    }
}
/deep/ .ivu-modal {
    top: 70px;
}
/deep/ .ivu-form-item {
    margin-bottom: 20px;
}
/deep/ .ivu-form-item-error-tip {
    padding-top: 3px;
}
/deep/ .ivu-input-wrapper {
    input {
        height: 40px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        color: #222222;
        padding-left: 16px;
    }
    input::placeholder {
        color: #b8b8b8;
    }
}
/deep/ .ivu-modal-header {
    display: none;
}
/deep/ .ivu-modal-footer {
    display: none;
}
/deep/ .ivu-modal-body {
    padding: 49px 83px;
}
</style>



// WEBPACK FOOTER //
// src/components/register-modal.vue